import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { OurAirports } from "./OurAirports/OurAirports";
import { OurBrand } from "./OurBrand/OurBrand";
import { OurPolicies } from "./OurPolicies/OurPolicies";
import { OurProfile } from "./OurProfile/OurProfile";
import { OurPoliciesDynamic } from "./OurPolicies/OurPoliciesDynamic";
import { OurProfileTabs } from "./OurProfile/OurProfileTabs";

export const CorporateProfile = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  useEffect(() => {
    if (!query.get("activeTab")) {
        navigate(`/dedicated/corporate/corporate-profile?activeTab=ourProfile&subActiveTab=ourProfilePageHeading`, {
          replace: true,
        });
    }
  }, []);

  useEffect(() => {
    if (approveId) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    const thirdChildActiveTab = query.get("thirdSubActiveTab");

    if (!activeTab) {
      navigate(`/dedicated/corporate/corporate-profile?activeTab=ourProfile&subActiveTab=ourProfilePageHeading`, {
        replace: true,
      });
    } else {
      if (activeTab == "ourProfile") {
        navigate(`/dedicated/corporate/corporate-profile?activeTab=ourProfile&subActiveTab=${subActiveTab ?? "ourProfilePageHeading"}`, {
          replace: true,
        });
      }
      if (activeTab == "ourBrand") {
        navigate(
          `/dedicated/corporate/corporate-profile?activeTab=ourBrand&subActiveTab=${query.get('subActiveTab')||'ourBrandPageHeading'}`,
          {
            replace: true,
          }
        );
      }
      if (activeTab === "ourAirports") {
        let defaultThirdSubActiveTab = "";
      
        switch (subActiveTab) {
          case "international":
            defaultThirdSubActiveTab = "klInternationalAirportForInternational_0";
            break;
          case "domestic":
            defaultThirdSubActiveTab = "melakaAirportForDomestic_0";
            break;
          case "stolports":
            defaultThirdSubActiveTab = "pangkorStolportForStolports_0";
            break;
          case "overseas":
            defaultThirdSubActiveTab = "istanbulSabihaGokcenAirportForOverseas_0";
            break;
          case "nextPage":
          case "ourAirportsPageHeading":
            defaultThirdSubActiveTab = "";
            break;
        }
      
        navigate(
          `/dedicated/corporate/corporate-profile?activeTab=ourAirports&subActiveTab=${
            subActiveTab || "ourAirportsPageHeading"
          }${defaultThirdSubActiveTab ? `&thirdSubActiveTab=${thirdChildActiveTab || defaultThirdSubActiveTab}` : ""}`,
          {
            replace: true,
          }
        );
      }   
      if (activeTab === "ourPolicies") {
        let defaultThirdSubActiveTab = "";
      
        switch (subActiveTab) {
          case "malaysiaAirportsHoldingsBerhad":
            defaultThirdSubActiveTab = "codeOfEthicsForMalaysiaAirportsHoldingsBerhad_0";
            break;
          case "subsidiaries":
            defaultThirdSubActiveTab = "malaysiaAirports1ForSubsidiaries_0";
            break;
          case "nextPage":
          case "ourPoliciesPageHeading":
            defaultThirdSubActiveTab = ""; 
            break;
        }
      
        navigate(
          `/dedicated/corporate/corporate-profile?activeTab=ourPolicies&subActiveTab=${
            subActiveTab || "ourPoliciesPageHeading"
          }${defaultThirdSubActiveTab ? `&thirdSubActiveTab=${thirdChildActiveTab || defaultThirdSubActiveTab}` : ""}`,
          {
            replace: true,
          }
        );
      }      
    }
  }, [query.get("activeTab"), query.get('subActiveTab')]);

  const items = [
    {
      label: "Our Profile",
      key: "ourProfile",
      children: <OurProfile />, //OurProfileTabs
    },
    {
      label: "Our Brand",
      key: "ourBrand",
      children: <OurBrand />,
    },
    {
      label: "Our Airports",
      key: "ourAirports",
      children: <OurAirports />,
    },
    {
      label: "Our Policies",
      key: "ourPolicies",
      children: <OurPoliciesDynamic />,
    },
  ];

  return (
    <ContentWrapper
      title={"Corporate Profile"}
      // loading={isLoading || isLoadingBrand || isLoadingprofileById || isLoadingpoliciesById }
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
